/**
 * Design utility functions
 */

/**
 * Convert hex color to rgba format with specified alpha/opacity
 * @param hex - Hex color string (e.g., '#1EBCD5')
 * @param alpha - Alpha/opacity value between 0 and 1
 * @returns RGBA color string
 */
export const hexToRgba = (hex: string, alpha: number): string => {
  // Handle 3-digit hex colors
  if (hex.length === 4) {
    const r = parseInt(hex[1] + hex[1], 16);
    const g = parseInt(hex[2] + hex[2], 16);
    const b = parseInt(hex[3] + hex[3], 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  
  // Handle 6-digit hex colors
  if (hex.length === 7) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  
  // Fallback for invalid hex
  console.warn(`Invalid hex color: ${hex}`);
  return `rgba(0, 0, 0, ${alpha})`;
}; 